import { TApiRoutes } from "./types";

export const ApiRoutes: TApiRoutes = {
    LOGIN: {
        methods: ["POST"],
        url: "/admin/auth/login",
    },

    BRANDS_ALL: {
        methods: ["GET"],
        url: "/admin/brands/all",
    },
    BRANDS: {
        methods: ["GET", "POST"],
        url: "/admin/brands",
    },
    BRAND: {
        methods: ["GET", "PUT", "DELETE"],
        url: "/admin/brands/#id",
    },
    BRAND_IMAGE: {
        methods: ["POST", "DELETE"],
        url: "/admin/brands/#id/logo",
    },

    CATEGORIES_ALL: {
        methods: ["GET"],
        url: "/admin/categories/all",
    },
    CATEGORIES: {
        methods: ["GET", "POST"],
        url: "/admin/categories",
    },
    CATEGORY: {
        methods: ["GET", "PUT", "DELETE"],
        url: "/admin/categories/#id",
    },
    CATEGORY_IMAGE: {
        methods: ["POST", "DELETE"],
        url: "/admin/categories/#id/image",
    },

    TAGS_ALL: {
        methods: ["GET"],
        url: "/admin/tags/all",
    },
    TAGS: {
        methods: ["GET", "POST"],
        url: "/admin/tags",
    },
    TAG: {
        methods: ["GET", "PUT", "DELETE"],
        url: "/admin/tags/#id",
    },
    TAG_IMAGE: {
        methods: ["POST", "DELETE"],
        url: "/admin/tags/#id/image",
    },
    TAG_MAIN: {
        methods: ["POST"],
        url: "/admin/tags/#id/main",
    },

    PLATFORMS_ALL: {
        methods: ["GET"],
        url: "/admin/platforms/all",
    },
    PLATFORMS: {
        methods: ["GET", "POST"],
        url: "/admin/platforms",
    },
    PLATFORM: {
        methods: ["GET", "PUT", "DELETE"],
        url: "/admin/platforms/#id",
    },
    PLATFORM_IMAGE: {
        methods: ["POST", "DELETE"],
        url: "/admin/platforms/#id/image",
    },

    ARTICLES: {
        methods: ["GET", "POST"],
        url: "/admin/articles",
    },
    ARTICLE: {
        methods: ["GET", "PUT", "DELETE"],
        url: "/admin/articles/#id",
    },
    ARTICLE_BANNER: {
        methods: ["POST", "DELETE"],
        url: "/admin/articles/#id/banner",
    },
    ARTICLE_THUMBNAIL: {
        methods: ["POST", "DELETE"],
        url: "/admin/articles/#id/thumbnail",
    },
    ARTICLE_PUBLISH: {
        methods: ["POST"],
        url: "/admin/articles/#id/publish",
    },
    ARTICLE_STATIC: {
        methods: ["POST"],
        url: "/admin/articles/#id/static",
    },

    PRODUCTS_ALL: {
        methods: ["GET"],
        url: "/admin/products/all",
    },
    PRODUCTS: {
        methods: ["GET", "POST"],
        url: "/admin/products",
    },
    PRODUCT: {
        methods: ["GET", "PUT", "DELETE"],
        url: "/admin/products/#id",
    },
    PRODUCT_IMAGE: {
        methods: ["POST", "DELETE"],
        url: "/admin/products/#id/image",
    },
    PRODUCT_PUBLISH: {
        methods: ["POST"],
        url: "/admin/products/#id/publish",
    },
    PRODUCT_EXCEL: {
        methods: ["GET", "POST"],
        url: "/admin/products/excel",
    },

    GALLERY: {
        methods: ["GET", "POST"],
        url: "/admin/gallery",
    },
    GALLERY_PHOTO: {
        methods: ["POST"],
        url: "/admin/gallery/photo",
    },
    GALLERY_ITEM: {
        methods: ["GET", "PUT", "DELETE"],
        url: "/admin/gallery/#id",
    },
    GALLERY_FILE: {
        methods: ["POST"],
        url: "/admin/gallery/file",
    },

    USER_PROFILE: {
        methods: ["GET"],
        url: "/admin/user/#id",
    },

    FILE_UPLOAD: {
        methods: ["POST"],
        url: "/api/customer/upload",
    },
    FORMS: {
        methods: ["GET"],
        url: "/api/site/7902eb2b167d469640cde6ae98f4d0f5/form/index",
    },
};
